import { BaseComponent } from '../base-component.js';
import { api } from '../../client/api.js';
import { escapeHtml } from '../../shared/utils.js';
import componentStyles from './auth-form.css?inline';

type State = 'idle' | 'loading' | 'success';

export class ForgotPassword extends BaseComponent {
  private state: State = 'idle';
  private error = '';

  protected styles(): string {
    return componentStyles;
  }

  protected template(): string {
    if (this.state === 'success') {
      return `
        <div class="auth-container">
          <header class="header">
            <div class="logo">Agentor</div>
          </header>
          <div class="auth-form">
            <ag-panel>
              <ag-panel-header>
                <h2>Check Your Email</h2>
              </ag-panel-header>
              <ag-panel-content>
                <ag-alert class="info">
                  If that email is registered, you'll receive reset instructions shortly.
                  Check your terminal output in dev mode.
                </ag-alert>
                <div class="mode-switcher">
                  <a href="/login">Back to Sign In</a>
                </div>
              </ag-panel-content>
            </ag-panel>
          </div>
        </div>
      `;
    }

    return `
      <div class="auth-container">
        <header class="header">
          <div class="logo">Agentor</div>
        </header>
        <div class="auth-form">
          <ag-panel>
            <ag-panel-header>
              <h2>Forgot Password</h2>
            </ag-panel-header>
            <ag-panel-content>
              ${this.error ? `<div class="error">${escapeHtml(this.error)}</div>` : ''}
              <p style="margin: 0 0 var(--margin-xl); color: var(--color-text-secondary); font-size: var(--font-size-s);">
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <form id="form">
                <ag-form-group>
                  <label for="email">Email</label>
                  <input type="email" id="email" name="email" required autocomplete="email">
                </ag-form-group>
                <button type="submit" ${this.state === 'loading' ? 'disabled' : ''}>
                  ${this.state === 'loading' ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
              <div class="mode-switcher">
                <a href="/login">Back to Sign In</a>
              </div>
            </ag-panel-content>
          </ag-panel>
        </div>
      </div>
    `;
  }

  protected afterRender(): void {
    this.$('#form')?.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  private async handleSubmit(e: Event): Promise<void> {
    e.preventDefault();

    const email = (this.$('#email') as HTMLInputElement).value;

    this.state = 'loading';
    this.error = '';
    this.render();
    this.afterRender();

    const result = await api.forgotPassword(email);

    if (result.success) {
      this.state = 'success';
    } else {
      this.state = 'idle';
      this.error = result.error || 'Something went wrong. Please try again.';
    }

    this.render();
    this.afterRender();
  }
}

customElements.define('forgot-password', ForgotPassword);
